import { useTranslation } from 'react-i18next';

import { Trash } from 'tabler-icons-react';

import { StyledButton, StyledSelect, StyledTextInput } from 'components/shared';
import { Option } from 'interfaces';

import styles from './PalletInputGroup.module.css';

type PalletInputGroupProps = {
   uuid: string;
   palletType: Option;
   palletsAmount: string;
   withRemoveButton: boolean;
   palletTypeError: boolean;
   palletsAmountError: boolean;
   availablePalletTypes: Option[];
   onRemove: () => void;
   onChange: (field: string, value: string | Option) => void;
};

const PalletInputGroup = ({
   uuid,
   palletType,
   palletsAmount,
   withRemoveButton,
   palletTypeError,
   palletsAmountError,
   availablePalletTypes,
   onRemove,
   onChange,
}: PalletInputGroupProps) => {
   const { t } = useTranslation();

   return (
      <div key={uuid} className={styles.container}>
         {withRemoveButton && (
            <div className={styles.removeBtnContainer}>
               <StyledButton type="button" onClick={onRemove} icon={<Trash />} variant="text" />
            </div>
         )}
         <div className={styles.inputsContainer}>
            <StyledSelect
               options={availablePalletTypes}
               onChange={(value: Option) => onChange('palletType', value)}
               value={palletType}
               label={t('damaged_by_client.table.pallet_type')}
               error={palletTypeError}
               mobileView
               classNames={{
                  container: styles.selectPalletTypeContainer,
                  select: styles.selectPalletType,
               }}
            />
            <StyledTextInput
               type="number"
               onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  onChange('palletsAmount', event.target.value)
               }
               value={palletsAmount}
               label={t('client_orders.table.pallets_amount')}
               error={palletsAmountError}
               className={styles.inputPalletsAmount}
            />
         </div>
      </div>
   );
};

export default PalletInputGroup;
